import type { FileInfo } from '../../../../api/files';

export const isPreviewableFile = (file: FileInfo): boolean => {
	const mimeType = file.meta['@mime']?.toLowerCase();

	if (!mimeType) return false;

	return (
		mimeType.startsWith('application/pdf') ||
		(mimeType.startsWith('image/') &&
			(mimeType === 'image/png' ||
				mimeType === 'image/jpeg' ||
				mimeType === 'image/jpg' ||
				mimeType === 'image/gif'))
	);
};
